import Component from './component';

Component.defaultProps = {
    containerProps: {},
    rounded: true,
};
export default Component;